import { Error } from '../../../pages/Error/error';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from '../../../pages/Home/home';
import { useBlockchainProvider } from '../../../providers/Blockchain/blockchainProvider';
import PrivateRoute from './PrivateRoute/PrivateRoute';
import { Account } from '../../../pages/Account/account';
import { Add } from '../../../pages/Add/add';
import { Summary } from '../../../pages/Summary/summary';
import { Header } from '../../Header/header';
import { Box, Flex, useDisclosure } from '@chakra-ui/react';
import { Menu } from '../../common/Menu/menu';
import Footer from '../../Footer/footer';
import { Games } from '../../../pages/Games/games';
import { ReactNode, useEffect, useMemo, useState } from 'react';
import i18n from 'i18next';
import { Color } from 'src/theme/color';
import { Creator } from 'src/pages/Creator/creator';
import { useEffectOnce } from 'src/lib/Hooks';

interface IPage {
	path: string;
	element: ReactNode;
}

const pages: ReadonlyArray<IPage> = [
	{
		path: '/',
		element: <Home />,
	},
];
const pageFallback = {
	path: '*',
	element: <Error />,
} as const;

export const privatePages: ReadonlyArray<IPage & { additionalPath: any }> = [
	{
		path: '/account',
		element: <Account />,
		additionalPath: [],
	},
	{
		path: '/add',
		element: <Add />,
		additionalPath: [],
	},
	{
		path: '/completed',
		element: <Summary />,
		additionalPath: [],
	},
	// {
	// 	path: '/creator',
	// 	element: <Creator />,
	// 	additionalPath: [],
	// },
	{
		path: '/yourGames',
		element: <Games />,
		additionalPath: [],
	},
] as const;

const Wrapper = () => {
	const blockchain = useBlockchainProvider();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const pageNodes = useMemo(
		() =>
			pages.map(page => (
				<Route
					path={page.path}
					element={page.element}
					key={page.path}
				/>
			)),
		[pages]
	);
	const privatePageNodes = useMemo(
		() =>
			privatePages.map(page =>
				PrivateRoute({
					path: page.path,
					key: page.path,
					element: page.element,
					additionalPath: page.additionalPath,
					isLoggedIn: blockchain.isLoggedIn,
					isLoading,
				})
			),
		[privatePages, isLoading, blockchain.isLoading, blockchain.isLoggedIn]
	);
	const pageFallbackNode = (
		<Route
			path={pageFallback.path}
			element={pageFallback.element}
		/>
	);

	/** TODO: documentation; implementation */
	useEffect(() => {
		if (performance.navigation.type === 1 || performance.navigation.type === 0) setIsLoading(true);
		setIsLoading(true);
		window.addEventListener('load', () => {
			setIsLoading(false);
		});
	}, []);

	useEffectOnce(() => {
		i18n.on('languageChanged', window.location.reload);
	});

	return (
		<BrowserRouter>
			<Box
				width="100%"
				p="0"
				bg={'#1D1D1D'}
				display="flex"
				justifyContent="center"
			>
				<Box
					width="100%"
					maxW="1240px"
				>
					<Header onOpenMobileMenu={onOpen} />
					<Menu
						isOpenMobileMenu={isOpen}
						onCloseMobileMenu={onClose}
					/>
				</Box>
			</Box>
			<Routes>
				{pageNodes}
				{privatePageNodes}
				<Route
					path="/creator"
					element={<Creator />}
				>
					<Route
						path="games"
						element={<Games />}
					/>
					<Route
						path="stats"
						element={<Flex>STATS</Flex>}
					/>
					<Route
						path="settings"
						element={<Flex>SETTINGS</Flex>}
					/>
				</Route>
				{isLoading || pageFallbackNode}
			</Routes>
			<Footer />
		</BrowserRouter>
	);
};

export default Wrapper;
